<template>
  <div class="global-fixed">
    <div class="dialog-main">
      <h4 class="dialog-title">{{dialogTitle}}</h4>
      <!-- <p class="content">{{content}}</p> -->
      <slot name="content"></slot>
      <!-- <p class="content">{{content}}</p> -->
      <div class="dialog-button">
        <span class="button-primary-inset" @click="handleClose">好的，我已保存</span>
      </div>
      <a-icon type="close" class="button-close" @click="handleClose"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogTitle: {
      type: String,
      default: '保存预报名号'
    },
    content: String
  },
  methods: {
    handleClose() {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="stylus" scoped>
.global-fixed
  position: fixed;
  top:0; bottom:0;left:0;right:0;
  background rgba(0,0,0,.5);
  .dialog-main
    width calc(100% - 75px);
    height 400px;
    position absolute;
    top 50%; left 50%;
    transform translate(-50%, -50%)
    background #fff;
    border-radius 10px;
    color #333;
    .dialog-title
      height 60px;
      font-size 20px;
      // line-height 60px;
      margin-top 30px
      font-weight normal;
      text-align center;
    .content
      height 200px;
      color #c1c2c3;
      display flex;
      align-items center;
      justify-content center;
    .button-close
      position absolute;
      top: 30px; right: 36px;
      font-size 30px;
  .dialog-button
    width 100%;
    height 140px;
    position absolute;
    bottom 0; left 0;
    // border-top: 1px solid #e2e2e2;
    display flex;
    justify-content center;
    align-items center;
</style>